import classNames from 'classnames/bind';
import styles from './ChangeCard.module.css';
import CardForm from '../../../components/CardForm';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {
  BIRTHDATE_LENGTH_ALERT,
  CHANGE_CARD,
  EMAIL_FORMAT_ALERT,
  ENTER_BIRTHDATE_ALERT,
  ENTER_CARD_NUMBER_ALERT,
  ENTER_EMAIL_ALERT,
  ENTER_MOBILE_ALERT,
  ENTER_NAME_ALERT,
  ENTER_PASSWORD_ALERT,
  MOBILE_LENGTH_ALERT,
  PASSWORD_LENGTH_ALERT,
  SELECT_CARD_VALID_DATE_ALERT,
  SELECT_INSTALLMENTS_ALERT,
} from '../../../constants';
import { checkEmailPattern } from '../../../utils/util';
import { PaymentInfo } from '../../../types/membership';
import { useGetPaymentInfoQuery } from '../../../services/membership';
import { useEffect, useState } from 'react';
import Complete from '../Payment/Complete';
import { useLocation } from 'react-router-dom';

export default function ChangeCard() {
  const cx = classNames.bind(styles);
  const { state } = useLocation();

  const { data, isLoading, refetch } = useGetPaymentInfoQuery();

  const [changedPaymentInfo, setChangedPaymentInfo] = useState<PaymentInfo>();
  const [isFailed, setIsFailed] = useState(false);

  const cardSchema = yup.object({
    paymentInfo: yup.object({
      cardNo1: yup.string().required(ENTER_CARD_NUMBER_ALERT),
      cardNo2: yup.string().required(ENTER_CARD_NUMBER_ALERT),
      cardNo3: yup.string().required(ENTER_CARD_NUMBER_ALERT),
      cardNo4: yup.string().required(ENTER_CARD_NUMBER_ALERT),
      expYear: yup.string().required(SELECT_CARD_VALID_DATE_ALERT),
      expMonth: yup.string().required(SELECT_CARD_VALID_DATE_ALERT),
      buyerName: yup.string().required(ENTER_NAME_ALERT),
      idNo: yup
        .string()
        .test(
          'len',
          BIRTHDATE_LENGTH_ALERT,
          (value) => !!value && (value.length === 6 || value.length === 10)
        )
        .required(ENTER_BIRTHDATE_ALERT),
      cardPw: yup
        .string()
        .required(ENTER_PASSWORD_ALERT)
        .min(2, PASSWORD_LENGTH_ALERT),
      cardQuota: yup.string().required(SELECT_INSTALLMENTS_ALERT),
      buyerTel: yup
        .string()
        .required(ENTER_MOBILE_ALERT)
        .min(10, MOBILE_LENGTH_ALERT),
      buyerEmail: yup
        .string()
        .required(ENTER_EMAIL_ALERT)
        .test('email', EMAIL_FORMAT_ALERT, (value) => checkEmailPattern(value)),
    }),
  });
  type FormData = yup.InferType<typeof cardSchema>;
  const methods = useForm({
    mode: 'onBlur',
    resolver: yupResolver(cardSchema),
    defaultValues: {
      paymentInfo: {
        cardNo1: '',
        cardNo2: '',
        cardNo3: '',
        cardNo4: '',
        expYear: '',
        expMonth: '',
        buyerName: '',
        idNo: '',
        cardPw: '',
        cardQuota: '00',
        buyerTel: '',
        buyerEmail: '',
      },
    },
  });
  const {
    formState: {},
  } = methods;

  const onSubmit = (res: any) => {
    setIsFailed(false);
    setChangedPaymentInfo(res.data);
  };

  useEffect(() => {
    setIsFailed(state?.resultType === 2 || state?.resultType === 0);
  }, [state?.resultType]);

  useEffect(() => {
    refetch();
  }, []);

  if (isLoading || !data) return null;

  return (
    <>
      <h2>{CHANGE_CARD}</h2>
      {changedPaymentInfo && !isFailed ? (
        <Complete
          nm="changeCard"
          paymentResult={changedPaymentInfo}
          resultType={state?.resultType}
        />
      ) : (
        <FormProvider {...methods}>
          <form>
            <CardForm
              name="changeCard"
              agreeList={data.agreeList}
              onSubmitCb={onSubmit}
            />
          </form>
        </FormProvider>
      )}
    </>
  );
}
